import React, { useContext, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
} from "@material-ui/core";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import validator from "validator";
import { getClientsList, InviteUser, ReInviteUser, RemoveUserInvite } from "../../../services/apiservices/client";
import { useEffect } from "react";
import styles from "../clients.module.scss";
import { Box,useMediaQuery } from "@mui/material";
import {
  CommonConfirmationDialog,
  CommonSuccessDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import {  Save, ArrowRight, Plus } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import AuthContext from "../../../hooks/authContext";
import { useParams } from "react-router";
import { useToast } from "../../../hooks/useToast";
import { generateP } from "../../../services/helpers";
import ContactsList from "./Contact/ContactList";
import ContactAutocomplete from "./Contact/ContactAutoComplete";

function Step2(props) {
  // const [stepContent, setContactValues] = useState({});
  const auth = useContext(AuthContext);
  const [clientsList, setClientsList] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactType, setContactType] = useState(null); 
  const [openDialog, setOpenDailog] = useState(false);
  const [openRevokeDialog, setOpenRevokeDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [updateEmailDialog, setUpdateEmailDialog] = useState(false);
  const [reinviteDialog, setReinviteDialog] = useState(false);
  const [edit, setEdit] = useState(false);
  const [tempData, setTemptData] = useState({ type: "", email: "" });
  const { clientId } = useParams();
  const { toast } = useToast();
  const [editType, setEditType] = useState(null);
  const [editingContact, setEditingContact] = useState(null);
  const [checkBox, setCheckbox] = useState(false);
  const [contactDraft, setContactDraft] = useState({
    name: "",
    email: "",
    mobileNumber: "",
  });
  const isMobile = useMediaQuery("(max-width:767px)");
  const {
    currentStep,
    goToStep,
    onCancelAll,
    stepContentValues,
    loading,
    classes,
    stepError,
    setStepError,
    setStepContentValue,
    companyData,
    stepContent,
    setContactValues
  } = props;

  const clientIds = clientId && clientId !== undefined ? clientId : auth?.newClientId;
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const callgetClientListapi = async () => {
    await getClientsList({}, (res) => {
      if (res) {
        setClientsList(res);
      } else {
        setClientsList([]);
      }
    });
  };
  useEffect(() => {
    callgetClientListapi();
  }, []);

  const handleDraftChange = (e) => {
    const { name, value } = e.target;
    const finalValue = name === "email" ? value.trim() : value;

  if (name === "email") {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

    let newEmailError = "";
    let emailExists = false;

    if (!emailRegex.test(finalValue)) {
      newEmailError = "Please enter a valid email address.";
    } else if (invalidSequenceRegex.test(finalValue)) {
      newEmailError = "Email contains invalid or unsupported characters.";
    }

    setStepError((prev) => ({
      ...prev,
      primary: [
        {
          ...prev.primary?.[0],
          email: newEmailError,
          emailExists: false,
        },
      ],
    }));
  }
    setContactDraft((prev) => ({ ...prev, [name]: finalValue }));
  };

  const setEditData = (editData) => {
    if (editData?.contact && props?.editData === false) {
      setContactValues({
        primary: editData?.contact?.primary || [],
        additional: editData?.contact?.additional || [],
      });
    } else if (props?.editData !== false) {

    const editPrimary = editData?.contact?.filter(c => c?.type === "primary") || [];
    const editAdditional = editData?.contact?.filter(c => c?.type === "additional") || [];

    // const stepPrimary = stepContentValues?.contact?.primary || [];
    // const stepAdditional = stepContentValues?.contact?.additional || [];

    const allPrimary = [...editPrimary];
    const allAdditional = [...editAdditional];

    // stepPrimary?.forEach(item => {
    //   const isDuplicate = allPrimary?.some(
    //     c => c.email === item.email || c.mobileNumber === item.mobileNumber
    //   );
    //   if (!isDuplicate) {
    //     allPrimary.push({ ...item, type: "primary" });
    //   }
    // });

    // stepAdditional?.forEach(item => {
    //   const isAlreadyInPrimary = allPrimary.some(
    //     c => c.email === item.email || c.mobileNumber === item.mobileNumber
    //   );
    //   const isDuplicate = allAdditional.some(
    //     c => c.email === item.email || c.mobileNumber === item.mobileNumber
    //   );
    //   if (!isAlreadyInPrimary && !isDuplicate) {
    //     allAdditional.push({ ...item, type: "additional" });
    //   }
    // });

    setContactValues({
      primary: allPrimary,
      additional: allAdditional,
    });
    }
  };
  useEffect(() => {
    if (props?.editData !== false) {
      setEditData(props?.editData);
    }
  }, [props?.editData]);

  useEffect(() => {
    if (props?.displayStep == 2 && stepContentValues?.contact && props?.editData === false) {
      setEditData(stepContentValues);
    }
  }, [props?.displayStep]);


  const isEmpty = (val) => typeof val === "undefined" || val.trim() === "";

  const validateEmail = (email) => {
    if (isEmpty(email)) return "Email is Required";
    if (!validator.isEmail(email.trim())) return "Email is Invalid";
    return "";
  };

  const validateMobile = (number) => {
    if (isEmpty(number)) return "";
    if (!validator.isMobilePhone(number, ["en-US", "en-IN"])) return "Invalid Mobile Number";
    return "";
  };

  const isDuplicateInClientList = (list, field, value) =>
    list?.some((client) =>
      Array.isArray(client.contact) && client?.contact?.some((c) => c[field] === value)
    );


  const validateContact = ({
    contact,
    clientsList,
    primaryList,
    isPrimary,
    isEdit,
    currentEmail,
    currentClientId,
    currentCompanyId
  }) => {
    const errors = {};
    const { name, email, mobileNumber } = contact;

    if (isEmpty(name)) {
      errors.name = "Name is Required";
    } else if (!isPrimary && primaryList?.[0]?.name === name) {
      errors.name = "Use a Different Name";
    }

    const isDuplicateForSameClient = (field, value) => {
    return clientsList?.some(client => {
      // if (client?.id === currentClientId)
      if (client?.companyId === currentCompanyId || client?.id === currentClientId)
      return Array.isArray(client?.contact) && client?.contact?.some(c => c[field] === value);
    });
  };

    const emailError = validateEmail(email);
    if (emailError) {
      errors.email = emailError;
    } else if (
      isDuplicateForSameClient("email", email)  &&
      (!isEdit || email !== currentEmail)
    ) {
      errors.email = "Email is already registered";
    } else if (!isPrimary && primaryList?.[0]?.email === email) {
      errors.email = "Use a Different Email";
    }

    const phoneError = validateMobile(mobileNumber);
    if (phoneError) {
      errors.mobileNumber = phoneError;
    } else if (
      isDuplicateForSameClient("mobileNumber", mobileNumber) &&
      (!isEdit || mobileNumber !== contact?.mobileNumber)
    ) {
      errors.mobileNumber = "Mobile Number already registered";
    } else if (!isPrimary && primaryList?.[0]?.mobileNumber === mobileNumber) {
      errors.mobileNumber = "Use a Different Mobile Number";
    }

    return errors;
  };


  const handleSaveContact = async () => {
    if (!contactDraft?.name && !contactDraft?.email && !contactDraft?.mobileNumber) return;

    const isEditing = edit === true;
    const isPrimary = editType === "primary";
    const primaryList = stepContent?.primary || [];
    const additionalList = stepContent?.additional || [];


    if ((editingContact?.email !== contactDraft?.email) && editingContact?.invite === true) {
      setUpdateEmailDialog(true);
      return;
    }

    const errors = validateContact({
      contact: contactDraft,
      clientsList,
      primaryList,
      isPrimary,
      isEdit: isEditing,
      currentEmail: editingContact?.email,
      currentClientId: clientIds,
      currentCompanyId: companyId,
    });

    const hasError = Object.values(errors).some((val) => val);

    if (hasError) {
      setStepError({ primary: [errors] });
      return;
    }

    const matchedContact = clientsList?.flatMap(client => client?.contact || [])?.find(c => c?.email === contactDraft?.email);

    const updatedPrimary = [{ 
      ...contactDraft, 
      ...(matchedContact?.invite === true ? { invite: true } : {}) 
    }];

    const shouldMakePrimary = checkBox === true && primaryList?.[0]?.email && contactDraft?.email !== primaryList?.[0]?.email;

    const proceedToUpdatePrimary = () => {
      setContactValues({ ...stepContent, primary: updatedPrimary });
      setStepContentValue((prev) => ({
        ...prev,
        contact: { ...prev.contact, primary: updatedPrimary },
      }));
    };

    const proceedToUpdateAdditional = () => {
      const updatedAdditionals = [{ 
        ...contactDraft, 
        ...(matchedContact?.invite === true ? { invite: true } : {}) 
      }];
      const updatedList = additionalList?.map((item) =>
        item?.email === editingContact?.email ? updatedAdditionals : item
      );
      setContactValues({ ...stepContent, additional: updatedList });
    };

    const proceedToAddAdditional = () => {
      const updatedAdditional = [...additionalList, { ...contactDraft }];
      setContactValues({ ...stepContent, additional: updatedAdditional });
    };

    if (isEditing) {
      if (isPrimary) {
        proceedToUpdatePrimary();
        setEdit(false);
      } else {
        proceedToUpdateAdditional();
        setEdit(false);

        if (shouldMakePrimary) {
          await onMakePrimary(contactDraft?.email);
        }
      }
    } else {
      if (!primaryList?.[0]) {
        proceedToUpdatePrimary();
      } else {
        proceedToAddAdditional();
        if (shouldMakePrimary) {
          await onMakePrimary(contactDraft?.email);
        }
      }
    }

    setContactDraft({ name: "", email: "", mobileNumber: "" });
    setEditingContact(null);
    setStepError({});
    setEdit(false);
    setEditType(null);
  };

  const handleConfirm = async() => {
    const id = clientId ? clientId : auth.newClientId;
    const companyName = `${companyData?.companyName}`
    const createdBy = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`
    setOpenDailog(false);
    setContactValues((prev) => {
      const updatedList = (prev[contactType] || [])?.map((c) =>
        c?.email === selectedContact?.email ? { ...c, invite: true, login: false } : c
      );

      return {
        ...prev,
        [contactType]: updatedList,
      };
    });
    await InviteUser(
    id,
    selectedContact,
    contactType,
    "invite",
    companyName,
    createdBy,
    () => {
      toast({ title: "Success", description: "User Invited successfully" });
    },
    (error) => {
      console.error("Invite failed:", error);
      toast({
        title: "Error",
        description: error?.message || "Invite failed",
        variant: "destructive",
      });
    }
  );
  };

  const handleClose = () => {
    setOpenDailog(false);
  };

  const handleRevokeConfirm = async() => {
    const id = clientId ? clientId : auth.newClientId;
    const companyName = `${companyData?.companyName}`
    const createdBy = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`
    setOpenRevokeDialog(false);
    setContactValues((prev) => {
      const updatedList = (prev[contactType] || [])?.map((c) =>
        c?.email === selectedContact?.email ? { ...c, invite: false, login: false } : c
      );

      return {
        ...prev,
        [contactType]: updatedList,
      };
    });
    await InviteUser(
    id,
    selectedContact,
    contactType,
    "revoke",
    companyName,
    createdBy,
    () => {
      toast({ title: "Success", description: "Invite revoked successfully" });
    },
    (error) => {
      console.error("Revoke failed:", error);
      toast({
        title: "Error",
        description: error?.message || "Revoke failed",
        variant: "destructive",
      });
    }
  );
  };

  const handleRevokeClose = () => {
    setOpenRevokeDialog(false);
  };

  const handleRemoveContact = async (type, emailToRemove) => {
    const contactToRemove = stepContent?.[type]?.find(
      (contact) => contact?.email === emailToRemove
    );

    setContactValues((prev) => ({
      ...prev,
      [type]: prev[type]?.filter((contact) => contact?.email !== emailToRemove),
    }));

    setStepContentValue((prev) => {
    const contactTypeList = prev?.contact?.[type];
    if (Array.isArray(contactTypeList) && contactTypeList?.length > 0) {
      return {
        ...prev,
        contact: {
          ...prev.contact,
          [type]: contactTypeList?.filter(
            (contact) => contact?.email !== emailToRemove
          ),
        },
      };
    }
    return prev;
  });

  if(contactToRemove?.invite === true){
    await RemoveUserInvite(emailToRemove,
      (res) => {
        console.log("Success:", res.message);
      },
      (err) => {
        console.error("Error:", err.message);
      }
    );
  }
    setTemptData({ title: "", email: "" });
  };

  const handleDeleteUserConfirm = () => {
    setDeleteDialog(false);
    handleRemoveContact(tempData?.type, tempData?.email);
  };

  const handleDeleteUserClose = () => {
    setDeleteDialog(false);
    setTemptData({ title: "", email: "" });
  };

  const handleEmailDailogClose = () => {
    setUpdateEmailDialog(false);
  };

  const handleReinviteUser = async () => {
    setReinviteDialog(false);
    const id = clientId || auth.newClientId;
    const password = generateP();
    const email = selectedContact?.email;
    const name = selectedContact?.name;
    const companyName = `${companyData?.companyName}`
    const createdBy = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`

    const formData = {
      email,
      password,
      name,
      companyName,
      createdBy
    };

    try {
      await ReInviteUser(formData);
      toast({
        title: "Success",
        description: "Invite re-sent successfully",
      });
    } catch (error) {
      console.error("Reinvite failed:", error);
      toast({
        title: "Error",
        description: error?.message || "Reinvite failed",
        variant: "destructive",
      });
    }
  };

  const handleReinviteClose = () => {
    setReinviteDialog(false);
    setTemptData({ title: "", email: "" });
  };

  const validatePrimaryContact = () => {
    let valid = true;
    let primaryError = stepError.primary ? stepError.primary : [];
    const { primary } = stepContent;
    primary?.map((primaryItem, index) => {
      const { name, email, mobileNumber } = primaryItem;

      let emailchy = [];
      clientsList?.forEach((itmr) => {
        if (Array.isArray(itmr.contact)) {
          itmr.contact.forEach((ittt) => {
            if (ittt.email === email) {
              emailchy.push(ittt.email);
            }
          });
        }
      });

      let phonechy = [];
      clientsList?.forEach((itmr) => {
        if (Array.isArray(itmr.contact)) {
          itmr.contact.forEach((ittt) => {
            if (ittt.mobileNumber === mobileNumber) {
              phonechy.push(ittt.mobileNumber);
            }
          });
        }
      });

      let primaryErrorItem = primaryError ? primaryError[index] : {};
      if (typeof name === "undefined" || name === "") {
        valid = false;
        primaryErrorItem = { ...primaryErrorItem, name: "Name is Required" };
      } else {
        primaryErrorItem = { ...primaryErrorItem, name: "" };
      }
      if (typeof email === "undefined" || email === "") {
        valid = false;
        primaryErrorItem = { ...primaryErrorItem, email: "Email is Required" };
      } else if (!validator.isEmail(email.trim())) {
        valid = false;
        primaryErrorItem = { ...primaryErrorItem, email: "Email is Invalid " };
      } else if (emailchy === email.trim()) {
        if (!props?.editData) {
          valid = false;
          primaryErrorItem = {
            ...primaryErrorItem,
            email: "Email is already registered ",
          };
        }
      } else {
        primaryErrorItem = { ...primaryErrorItem, email: "" };
      }
      if (typeof mobileNumber !== "undefined" && mobileNumber !== "") {
        if (!validator.isMobilePhone(mobileNumber, ["en-US", "en-IN"])) {
          valid = false;
          primaryErrorItem = {
            ...primaryErrorItem,
            mobileNumber: "Invalid Mobile Number",
          };
        } else if (phonechy === mobileNumber) {
          if (!props?.editData) {
            valid = false;
            primaryErrorItem = {
              ...primaryErrorItem,
              mobileNumber: "Mobile Number already registered",
            };
          }
        } else {
          primaryErrorItem = { ...primaryErrorItem, mobileNumber: "" };
        }
      } else {
        primaryErrorItem = { ...primaryErrorItem, mobileNumber: "" };
      }
      primaryError[index] = primaryErrorItem;
      return primaryItem;
    });
    return { valid, primaryError: primaryError };
  };

  const validateAdditionalContact = () => {
    let valid = true;
    let additionalError = stepError.additional ? stepError.additional : [];
    const { additional, primary } = stepContent;
    additional?.map((additionalItem, index) => {
      const { name, email, mobileNumber } = additionalItem;

      let additionalErrorItem = additionalError ? additionalError[index] : {};
      const hasPrimary = Array.isArray(primary) && primary.length > 0;
      if (
        (typeof name === "undefined" || name === "") &&
        (typeof email === "undefined" || email === "")
      ) {
      } else {
        if (typeof name === "undefined" || name === "") {
          valid = false;
          additionalErrorItem = {
            ...additionalErrorItem,
            name: "Name is Required",
          };
        } else if (hasPrimary && name === primary?.[0]?.name) {
          valid = false;
          additionalErrorItem = {
            ...additionalErrorItem,
            name: "Use a Diffrent Name",
          };
        } else {
          additionalErrorItem = { ...additionalErrorItem, name: "" };
        }
        if (typeof email === "undefined" || email === "") {
          valid = false;
          additionalErrorItem = {
            ...additionalErrorItem,
            email: "Email is Required",
          };
        } else if (!validator?.isEmail(email?.trim())) {
          valid = false;
          additionalErrorItem = {
            ...additionalErrorItem,
            email: "Email is Invalid ",
          };
        } else if (hasPrimary && email?.trim() === primary?.[0]?.email?.trim()) {
          valid = false;
          additionalErrorItem = {
            ...additionalErrorItem,
            email: "Use a Diffrent Email ",
          };
        } else {
          additionalErrorItem = { ...additionalErrorItem, email: "" };
        }
        if (typeof mobileNumber !== "undefined" && mobileNumber !== "") {
          if (!validator?.isMobilePhone(mobileNumber, ["en-US", "en-IN"])) {
            valid = false;
            additionalErrorItem = {
              ...additionalErrorItem,
              mobileNumber: "Invalid Mobile Number",
            };
          } else if (hasPrimary && mobileNumber === primary?.[0]?.mobileNumber) {
            valid = false;
            additionalErrorItem = {
              ...additionalErrorItem,
              mobileNumber: "Use a Diffrent Mobile Number ",
            };
          } else {
            additionalErrorItem = { ...additionalErrorItem, mobileNumber: "" };
          }
        } else {
          additionalErrorItem = { ...additionalErrorItem, mobileNumber: "" };
        }
      }
      additionalError[index] = additionalErrorItem;
      return additionalItem;
    });

    return { valid, additionalError: additionalError };
  };

  const validateAndGoNext = async () => {
    let isValid = true;
    const { primary, additional } = stepContent;
    let contactErrorsMessages = stepError;
    if (primary?.length > 0) {
      contactErrorsMessages = {
        ...contactErrorsMessages,
        primaryContactError: "",
      };
      let checkPrimaryValid = validatePrimaryContact();
      if (checkPrimaryValid.valid !== true) {
        isValid = false;
        contactErrorsMessages = {
          ...contactErrorsMessages,
          primary: checkPrimaryValid?.primaryError,
        };
      } else {
        contactErrorsMessages = {
          ...contactErrorsMessages,
          primary: checkPrimaryValid?.primaryError,
        };
      }
    // } else if (primary?.length === 0 && additional?.length > 0) {
    //   isValid = true;
    } else {
      isValid = false;
      contactErrorsMessages = {
        ...contactErrorsMessages,
        primaryContactError: "Primary Address is Required",
      };
    }
    if (additional?.length > 0) {
      let checkAdditionalValid = validateAdditionalContact();
      if (checkAdditionalValid.valid !== true) {
        isValid = false;
        contactErrorsMessages = {
          ...contactErrorsMessages,
          additional: checkAdditionalValid?.additionalError,
        };
      } else {
        contactErrorsMessages = {
          ...contactErrorsMessages,
          additional: checkAdditionalValid?.additionalError,
        };
      }
    }
    setStepError(contactErrorsMessages);
    if (isValid) {
        props?.validateAndGoNext &&
        props?.validateAndGoNext({
          contact: stepContent,
        });
    }
  };

  const handleEditContact = (contact, type) => {
    setEditType(type);
    setContactDraft({
      name: contact?.name,
      email: contact?.email,
      mobileNumber: contact?.mobileNumber,
    });
    setEditingContact(contact); 
    setEdit(true);
  };


  const onMakePrimary = async (email) => {
    const id = clientId ? clientId : auth.newClientId;
    const additionalContacts = stepContent?.additional || [];
    const primaryContact = stepContent?.primary?.[0];

    const contactToMakePrimary = additionalContacts?.find(contact => contact?.email === email);
    const updatedAdditionalContacts = additionalContacts?.filter(contact => contact?.email !== email);
    
    if (primaryContact) {
      updatedAdditionalContacts?.push(primaryContact);
    }

    setContactValues(prevStepContent => ({
      ...prevStepContent,
      primary: [contactToMakePrimary],
      additional: updatedAdditionalContacts
    }));
  };

  const maskPhone = (phone) => {
    if (!phone) return "";
    return phone.slice(0, 2) + "•••" + phone.slice(-4);
  };



const contactsData = clientsList?.flatMap(client =>
  (client?.contact || [])?.map(contact => ({
    name: contact?.name,
    email: contact?.email,
    mobileNumber: contact?.mobileNumber,
    clientName: client?.clientName,
    clientId: client?.id
  }))
);

  const handleSelect = (selected) => {
    if (selected && typeof selected !== "string") {
      setContactDraft({
        ...contactDraft,
        name: selected.name,
        email: selected.email,
        mobileNumber: selected.mobileNumber
      });
    }
  };

  const renderOption = (props, option) => (
    <Box
      component="li"
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1
      }}
    >
      <Typography variant="subtitle1">{option.name}</Typography>
      <Typography variant="body2" color="text.secondary">
        📧 {option.email} | 📱 {maskPhone(option.mobileNumber)}
      </Typography>
    </Box>
  );

  return (
    <>
      {!clientId && (
        <div
          style={{
            backgroundColor: "#FFF8E5",
            border: "1px solid #F1C40F",
            borderRadius: "8px",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginTop: "16px",
            marginBottom: "8px",
            fontSize: "14px",
            color: "#A75E00",
            fontWeight: 500,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L4.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <span>
            This client is incomplete and has been set to <strong>Inactive</strong> until all details are completed and saved.
          </span>
        </div>
      )}

      <div className="mv-15">
        <Card className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]` }>
          <CardContent className="p-24">
            <div className="d-flex flex-direction-column mb-24">
              <h2 className={`${styles.cardProfileTitle} dark:text-white`}>Contacts</h2>
              <p
                className="mt-16"
                style={{
                  color: "#6B7280",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontWeight: "500",
                }}
              >
                Add and manage contacts associated with this client.
              </p>
            </div>

            <div
              className={
                isMobile
                  ? "d-flex flex-direction-column w-100 "
                  : "d-flex flex-center flex-space-between w-100"
              }
            >
              <div className={isMobile ? "w-100 mv-10" : "w-100 mh-10"}>
                <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                  Name
                </Typography>
                <div className="mt-5">
                  <Input
                    name="name"
                    id="name"
                    placeholder="Name *"
                    value={contactDraft.name || ""}
                    onChange={handleDraftChange}
                    tabIndex={1}
                  />
                  {typeof stepError?.primary?.[0]?.name !== "undefined" &&
                    stepError?.primary?.[0]?.name !== "" && (
                      <span className="small error color-danger">
                        {stepError?.primary?.[0]?.name}
                      </span>
                    )}
                </div>
              </div>

              <div className={isMobile ? "w-100 mv-10" : "w-100 mh-10"}>
                <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                  Email
                </Typography>
                <div className="mt-5">
                  <ContactAutocomplete
                      label="Email"
                      field="email"
                      inputValue={contactDraft?.email}
                      contactsData={contactsData}
                      contactDraft={contactDraft}
                      setContactDraft={setContactDraft}
                      tabIndex={2}
                    />
                  {/* <Input
                    name="email"
                    id="email"
                    placeholder="Email *"
                    onChange={handleDraftChange}
                    value={contactDraft.email || ""}
                    tabIndex={2}
                  /> */}
                  {typeof stepError?.primary?.[0]?.email !== "undefined" &&
                    stepError?.primary?.[0]?.email !== "" && (
                      <span className="small error color-danger">
                        {stepError?.primary?.[0]?.email}
                      </span>
                    )}
                  {stepError?.primary?.[0]?.emailExists === true && (
                    <span className="small error color-danger">
                      Email is already registered
                    </span>
                  )}
                </div>
              </div>

              <div className={isMobile ? "w-100 mv-10" : "w-100 mh-10"}>
                <Typography variant="body" className={`${styles.labelSm} dark:text-white`}>
                  Phone
                </Typography>
                <div className="mt-5">
                  <Input
                    type="tel"
                    name="mobileNumber"
                    id="mobileNumber"
                    placeholder="Phone *"
                    inputMode="numeric"
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleDraftChange(e);
                      }
                    }}
                    value={contactDraft?.mobileNumber || ""}
                    tabIndex={3}
                  />
                  {typeof stepError?.primary?.[0]?.mobileNumber !==
                    "undefined" &&
                    stepError?.primary?.[0]?.mobileNumber !== "" && (
                      <span className="small error color-danger">
                        {stepError?.primary?.[0]?.mobileNumber}
                      </span>
                    )}
                </div>
              </div>
            </div>
            {edit && (
              <div className="ml-12 mt-15">
                <label
                  className={`d-flex flex-center ${styles.customCheckboxWrapper}`}
                  style={{ cursor: "pointer", gap: "8px" }}
                >
                  <input
                    type="checkbox"
                    checked={editType === "primary" || checkBox}
                    onChange={() => setCheckbox(!checkBox)}
                    className={`${styles.customCheckbox} ${
                      editType === "primary" ? styles.forceGreen : ""
                    }`}
                    disabled={editType === "primary"}
                  />
                  <span
                    className={`${styles.checkmark} ${
                      editType === "primary" ? styles.forceGreen : ""
                    }`}
                  ></span>
                  <span
                    className="ml-10"
                    style={{
                      color:
                        editType === "primary" || checkBox
                          ? "#28a745"
                          : "#020817",
                      fontWeight: "500",
                    }}
                  >
                    Make User Primary
                  </span>
                </label>
              </div>
            )}
            <div className="mv-20">
              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor:
                    contactDraft.name &&
                    contactDraft.email &&
                    contactDraft.mobileNumber
                      ? "green"
                      : "gray",
                }}
                onClick={handleSaveContact}
                disabled={
                  !contactDraft.name ||
                  !contactDraft.email ||
                  !contactDraft.mobileNumber
                }
              >
                <Plus className="mr-10 h-4 w-4" />{" "}
                {edit === true ? "Update Contacts" : "Add Contacts"}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <ContactsList
        stepContent={stepContent}
        isMobile={isMobile}
        setSelectedContact={setSelectedContact}
        setContactType={setContactType}
        setOpenDailog={setOpenDailog}
        setReinviteDialog={setReinviteDialog}
        handleEditContact={handleEditContact}
        setEdit={setEdit}
        setOpenRevokeDialog={setOpenRevokeDialog}
        setDeleteDialog={setDeleteDialog}
        setTemptData={setTemptData}
      />
  
      <div className={`stepContent w-100`}>
        <div className="buttonsWrap d-flex flex-center flex-space-between mv-20">
          <DialogComponent
            buttonWrapClassName="d-inline"
            buttonClassName="bg-white dark:bg-gray-800"
            buttonProps={{
              variant: "outline",
              disabled: loading,
            }}
            buttonLabel={"Cancel"}
            ModalTitle={"Are you sure you want to cancel this entry?"}
            ModalContent={<ConfirmCancel onCancelAll={onCancelAll} />}
          />
          <Button
            color="primary"
            variant="contained"
            className={
              isMobile
                ? "ml-15 bg-green color-white"
                : "w-full sm:w-auto mr-15 bg-green color-white"
            }
            onClick={() => validateAndGoNext()}
            disabled={loading === true ? true : false}
          >
            <Save className="mr-2 h-4 w-4" />{" "}
            {loading ? "Loading..." : "Save & Proceed"}
            <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </div>
      </div>

      {openDialog && (
        <CommonConfirmationDialog
          open={openDialog}
          onConfirm={handleConfirm}
          onClose={handleClose}
          title="Invite Client to System"
          message="An invitation will be sent to this contact, giving them access to your account as a client user."
          meessge1="They will be able to view their information and communicate with your team."
          buttonTitle="Send Invite"
        />
      )}
      {openRevokeDialog && (
        <CommonConfirmationDialog
          open={openRevokeDialog}
          onConfirm={handleRevokeConfirm}
          onClose={handleRevokeClose}
          title="Revoke Client Invite"
          message="Are you sure you want to revoke this invitation? The contact will no longer have access to your account."
          buttonTitle="Revoke Invite"
        />
      )}
      {deleteDialog && (
        <CommonConfirmationDialog
          open={deleteDialog}
          onConfirm={handleDeleteUserConfirm}
          onClose={handleDeleteUserClose}
          title="Delete Client User"
          message="Are you sure you want to delete this user? This action cannot be undone."
          buttonTitle="Delete User"
        />
      )}
      {reinviteDialog && (
        <CommonConfirmationDialog
          open={reinviteDialog}
          onConfirm={handleReinviteUser}
          onClose={handleReinviteClose}
          title="Re-Invite Client User"
          message="Are you sure you want to re-invite this user? This action cannot be undone."
          buttonTitle="Re-Invite User"
        />
      )}
      {updateEmailDialog && (
        <CommonSuccessDialog
          open={updateEmailDialog}
          onClose={handleEmailDailogClose}
          title="Email Update Restricted"
          message="This email address is currently associated with an active CMS login invitation. To update the email, please revoke the existing invitation first and then proceed with the update."
        />
      )}
    </>
  );
}
export default Step2;
